<template>
  <div id="admin">
    <v-card>
      <v-card-title primary-title>
        <div>
          <h3 class="headline mb-0">Admin</h3>
        </div>
      </v-card-title>
      <v-card-actions>
        <v-switch v-model="status" color="primary" label=" Live Game Status"></v-switch>
      </v-card-actions>
      <v-divider class="pa-2"></v-divider>
      <div class="pa-4 d-flex justify-end">
        <!-- <v-btn @click="pushUpdate()">Push Update</v-btn> -->
        <v-btn v-if="!openEntries" text color="primary" @click="viewEntries()" :loading="loadingEntries">View All Entries</v-btn>
        <v-btn v-if="openEntries" text color="secondary" @click="openEntries = false" :loading="loadingEntries">Close Entries</v-btn>
      </div>
      <div v-if="openEntries">
        <v-list max-height="300px"  class="overflow-y-auto">
          <v-list-item v-for="(pick,i) in picks" :key="i">{{i+1}} - {{pick.name}} - <span v-if="users[pick.uid].fname">{{users[pick.uid].fname}} {{users[pick.uid].lname}}</span><span v-if="users[pick.uid].firstName">{{users[pick.uid].firstName}} {{users[pick.uid].lastName}}</span></v-list-item>
        </v-list>
      </div>
      <v-divider class="pa-2"></v-divider>
      <v-card-text>
        <v-tabs v-model="currentRegion" fixed-tabs>
          <v-tab v-for="region in regions" :key="region">
            {{region}}
          </v-tab>
        </v-tabs>
          <v-tabs-items v-model="currentRegion">
            <v-tab-item v-for="(region, rKey) in regions" :key="region">
              <div style="max-height: 300px" class="overflow-y-auto">
                  <div v-for="(team, key) in teams[currentRegion]" :key="team.name" class="pa-2 rounded bg2 ma-2">
                    <v-row>
                      <v-col cols="2" class="title pa-2">{{team.seed}}</v-col>
                      <v-col cols="8" class="left title pa-2">{{team.name}}</v-col>
                      <v-col cols="2" class="pa-2" @click="changeElim(rKey, key)">
                        <v-icon v-if="!team.elim" class="green--text">mdi-check</v-icon>
                        <v-icon v-else class="red--text">mdi-close</v-icon>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="2" class="justify-center pa-0">
                        <v-icon v-if="team.round > 0 && !team.elim" @click="changeRound(rKey, key, -1)">mdi-minus-circle</v-icon>
                      </v-col>
                      <v-col cols="6" class="justify-center pa-0">{{rounds[team.round]}}</v-col>
                      <v-col cols="2" class="justify-center pa-0">
                        <v-icon v-if="team.round < 6 && !team.elim" @click="changeRound(rKey, key, 1)">mdi-plus-circle</v-icon>
                      </v-col>
                    </v-row>
                  </div>
              </div>
            </v-tab-item>  
          </v-tabs-items>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { db } from '@/db'

export default {
  name: 'picks',
  data() {
    return {
      currentRegion: 0,
      regions: ["West", "East", "South", "Midwest"],
      rounds: ['1st Round', 'Round of 32', 'Sweet 16', 'Elite 8', 'Final 4', 'Semis', 'Champ'],
      users: {},
      openEntries: false,
      loadingEntries: false,
      pendingUpdate: false,
      update: {},
    }
  },
  computed: {
    picks() {
      return this.$store.getters.picks
    },
    status: {
      get() {
        return this.$store.getters.status
      },
      set(v) {
        this.$store.dispatch('setStatus', Number(v))
      }
    },
    teams() {
      return this.$store.getters.teams
    },
    sortedTeams() {
      return this.teams
    },
  },
  methods: {
    updateStatus() {
      console.log(this.currentStatus);
    },
    changeRound(region, teamKey, num) {
      this.$store.dispatch('updateTeamRound', {rKey: region, tKey: teamKey, num: num}).then(() => {
        console.log('round')
        this.calcPicks()
      })
    },
    changeElim(region, teamKey) {
      this.$store.dispatch('updateTeamElim', {rKey: region, tKey: teamKey}).then(() => {
        console.log('elim')
        this.calcPicks()
      })
    },
    viewEntries() {
      this.loadingEntries = true
      let u = {}
      db.collection('users').get().then(users => {
        users.forEach(user => {
          u[user.id] = user.data()
        })
        this.users = u
        this.loadingEntries = false
        this.openEntries = true
      })
    },
    calcPicks() {
      if (!this.pendingUpdate) {
        this.pendingUpdate = true
        setTimeout(() => {
          let m = [0,1,2,4,8,16,32]
          this.teams.forEach(r => {
            for (let t in r) {
              let s = 0
              for (var i = 0; i <= r[t].round; i++) {
                s += (r[t].seed * m[i]);
              }
              r[t].total = s
            }
          })
          let newPicks = this.picks.map(pick => {
            let t = pick.left
            pick.teams.forEach(team => {
              let r = Number(team.substring(1,2)) - 1
              t += this.teams[r][team].total
            })
            pick.total = t
            return pick
          })
          //console.log(newPicks);
          db.collection('data').doc('2021').update({teams: this.teams, picks: newPicks}).then(() => {
            console.log('update');
            this.pendingUpdate = false
          })
        },15000)
      } else {
        console.log('pending')
      }
      
    },
    // pushUpdate() {
    //   let u = {}
    //   db.collection('data').doc('test').get().then(doc => {
    //     doc.data().picks.forEach(pick => {
    //       if (pick.name == 'DJ - B1G') {
    //         console.log(pick);
    //         u = pick
    //       }
    //     })
    //     this.$store.dispatch('pushPick', u)
    //   })
      
    // }
  },
  mounted() {
    
  },
  watch: {

  }
}
</script>

<style>

</style>
